import { ApiEndpointUrl } from "../../common";
export const topdealPoint = { list: ApiEndpointUrl + "products?category_id=1" };
